<div style="display: flex">
    <p-dialog header="Add Rate Override" [(visible)]="showAddDialog" [maximizable]="false" [closable]="true"  [modal]="true"
        [closeOnEscape]="false" [style]="{ width: '25vw' }">
        <!-- <span class="p-text-secondary block mb-5">
            Build rows in cumulative entry grid with selected filters.
        </span> -->

        <form [formGroup]="addFormGroup" #addForm="ngForm" id="addForm">
            <p-floatlabel variant="on" class="w-full mb-3 mt-2">
                <p-select styleClass="w-full" inputId="csel" appendTo="body" [options]="contractsSelectItem"
                    [filter]="true" formControlName="contract">
                </p-select>
                <label for="csel">Contract</label>
            </p-floatlabel>
            <p-floatlabel variant="on" class="w-full mb-3">
                <p-multiSelect styleClass="w-full" inputId="cnsel" maxSelectedLabels="1" appendTo="body" [options]="chargeNumbersSelectItem"
                    [filter]="true" formControlName="chargenumber">
                </p-multiSelect>
                <label for="cnsel">Charge Number(s)</label>
            </p-floatlabel>
            <p-floatlabel variant="on" class="w-full mb-3">
                <p-select styleClass="w-full" inputId="ccsel" [options]="costCentersSelectItem" [filter]="true" appendTo="body"
                    [autoDisplayFirst]="false" formControlName="costcenter">
                </p-select>
                <label for="ccsel">Cost Center</label>
            </p-floatlabel>
            <p-floatlabel variant="on" class="w-full mb-3">
                <p-datepicker styleClass="w-full" inputId="sd" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030" appendTo="body"
                    [showIcon]="true" id="ed" formControlName="startdate">
                </p-datepicker>
                <label for="sd">Start Date</label>
            </p-floatlabel>
            <p-floatlabel variant="on" class="w-full mb-3">
                <p-datepicker styleClass="w-full" inputId="ed" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030" appendTo="body"
                    [showIcon]="true" id="ed" formControlName="enddate">
                </p-datepicker>
                <label for="ed">End Date</label>
            </p-floatlabel>
            <p-floatlabel variant="on" class="w-full mb-3">
                <input class="w-full" inputId="frr" pInputText type="text" formControlName="FR" />
                <label for="frr">FR Rate</label>
            </p-floatlabel>
            <p-floatlabel variant="on" class="w-full mb-3">
                <input class="w-full" inputId="ohr" pInputText type="text" formControlName="OH" />
                <label for="ohr">OH Rate</label>
            </p-floatlabel>
            <p-floatlabel variant="on" class="w-full mb-3">
                <input class="w-full" inputId="mhr" pInputText type="text" formControlName="MH" />
                <label for="mhr">MH Rate</label>
            </p-floatlabel>
            <p-floatlabel variant="on" class="w-full mb-3">
                <input class="w-full" inputId="mh2r" pInputText type="text" formControlName="MH2" />
                <label for="mh2r">MH2 Rate</label>
            </p-floatlabel>
            <p-floatlabel variant="on" class="w-full mb-3">
                <input class="w-full" inputId="gar" pInputText type="text" formControlName="GA" />
                <label for="gar">GA Rate</label>
            </p-floatlabel>
        </form>

        <ng-template #footer>
            <button pButton pRipple severity="success" text label="Submit" (click)="addRateCeiling()"></button>
        </ng-template>
    </p-dialog>
</div>

<!-- <div style="margin-bottom: .5em;">
    <p-accordion>
        <p-accordionTab header="Add Rate Override" [selected]="false">
            <form [formGroup]="addFormGroup" #addForm="ngForm" id="addForm">
                <p-toolbar>
                    <span class="p-float-label">
                        <p-dropdown appendTo="body" [options]="contractsSelectItem" placeholder="Contract"
                            [filter]="true" formControlName="contract">
                        </p-dropdown>
                        <label for="float-dd">Contract</label>
                    </span>
                    <span class="p-float-label">
                        <p-multiSelect maxSelectedLabels="1" appendTo="body" [options]="chargeNumbersSelectItem"
                            [filter]="true" placeholder="Charge Number" formControlName="chargenumber">
                        </p-multiSelect>

                        <label for="float-dd">Charge Number</label>
                    </span>
                    <span class="p-float-label">
                        <p-dropdown [options]="costCentersSelectItem" [filter]="true" appendTo="body"
                            [autoDisplayFirst]="false" placeholder="Cost Center" formControlName="costcenter">
                        </p-dropdown>
                        <label for="float-dd">Cost Center</label>
                    </span>
                    <span class="p-float-label">
                        <p-calendar [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030" appendTo="body"
                            [showIcon]="false" id="ed" formControlName="startdate">
                        </p-calendar>
                        <label for="float-dd">Start Date</label>
                    </span>
                    <span class="p-float-label">
                        <p-calendar [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030" appendTo="body"
                            [showIcon]="false" id="ed" formControlName="enddate">
                        </p-calendar>
                        <label for="float-dd">End Date</label>
                    </span>
                    <div style="display: flex; flex-direction: row;">
                        <span *ngIf="this.showFR" class="p-float-label" style="padding-right: .5em;">
                            <input class="rate-add-input" pInputText type="text" formControlName="FR" />
                            <label for="float-dd">FR Rate</label>
                        </span>
                        <span class="p-float-label" style="padding-right: .5em;">
                            <input class="rate-add-input" pInputText type="text" formControlName="OH" />
                            <label for="float-dd">OH Rate</label>
                        </span>
                        <span *ngIf="this.showMH" class="p-float-label" style="padding-right: .5em;">
                            <input class="rate-add-input" pInputText type="text" formControlName="MH" />
                            <label for="float-dd">MH Rate</label>
                        </span>
                        <span *ngIf="this.showMH" class="p-float-label" style="padding-right: .5em;">
                            <input class="rate-add-input" pInputText type="text" formControlName="MH2" />
                            <label for="float-dd">MH2 Rate</label>
                        </span>
                        <span class="p-float-label">
                            <input class="rate-add-input" pInputText type="text" formControlName="GA" />
                            <label for="float-dd">GA Rate</label>
                        </span>
                    </div>
                    <button pButton pRipple class="p-button-secondary" icon="pi pi-plus-circle" label="Add Rate Ceiling"
                        (click)="addRateCeiling()"></button>
                </p-toolbar>
            </form>
        </p-accordionTab>
    </p-accordion>
</div> -->
<div class="card">
    <p-accordion>
        <p-accordionTab [selected]="true">
            <ng-template #header>
                <div class="flex justify-content-between align-items-center w-full">
                    <span>Rate Overrides</span>

                </div>
            </ng-template>
            <div class="flex items-center" style="padding: .5em;">
                <button class="justify-end" pButton pRipple severity="primary" label="Add Rate Override" title="Add Rate Override" (click)="showAddDialog = true; $event.stopPropagation()"></button>
                <div class="flex items-center align-items-center ml-2">
                    <p-checkbox inputId="inactive" binary="true" [(ngModel)]="includeInactive" (onChange)="includeInactiveChecked($event)"></p-checkbox>
                    <label for="inactive" class="ml-2">Include expired</label>
                </div>
                <p-message *ngIf="this.IsDeleteError" severity="danger"
                    text="The selected rate ceiling period contains processed activity, it cannot be deleted."></p-message>
            </div>

            <p-table stripedRows #RateTable [scrollable]="true" [virtualScroll]="true" [style]="{ 'max-width': '100%' }" scrollHeight="65vh"
                [value]="rateCeilings" editMode="row" (onEditInit)="onEditInit($event)"
                (onRowEditSave)="onRowEditSave($event)" dataKey="Rateceilingid" >
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="17" style="text-align: center">
                            <div class="tabulator-placeholder">
                                <span> No Data Available </span>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr class="tabulator-header">
                        <th class="edit-cell" pFrozenColumn [frozen]="IsColumnFrozen"></th>
                        <th class="status-cell" pFrozenColumn [frozen]="IsColumnFrozen">
                            <i class="pi pi-exclamation-circle"></i>
                        </th>
                        <th pSortableColumn="Contractdesc" pFrozenColumn [frozen]="IsColumnFrozen">
                            Contract
                            <p-sortIcon field="Contractdesc" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order">
                            </p-sortIcon>
                            <p-columnFilter field="Contractlistid" matchMode="in" display="menu" [showMatchModes]="false"
                                [showOperator]="false" [showAddButton]="false" class="ml-auto">
                                <ng-template #filter let-value let-filter="filterCallback">
                                    <p-multiSelect defaultLabel="Filter" maxSelectedLabels="1" appendTo="body"
                                        [options]="this.contractsFilterSelectItem" [filter]="true"
                                        styleClass="w-full"
                                                [ngModel]="value"
                                                (ngModelChange)="filter($event)">
                                    </p-multiSelect>
                                </ng-template>
                            </p-columnFilter>
                        </th>
                        <th pSortableColumn="Chargenumber">
                            Charge Number
                            <p-sortIcon field="Chargenumber" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order">
                            </p-sortIcon>
                            <p-columnFilter field="CNListid" matchMode="in" display="menu" [showMatchModes]="false"
                                [showOperator]="false" [showAddButton]="false" class="ml-auto">
                                <ng-template #filter let-value let-filter="filterCallback">
                                    <p-multiSelect defaultLabel="Filter" maxSelectedLabels="1" appendTo="body"
                                        [options]="this.chargeNumbersFilterSelectItem" [filter]="true"
                                        styleClass="w-full"
                                                [ngModel]="value"
                                                (ngModelChange)="filter($event)">
                                    </p-multiSelect>
                                </ng-template>
                            </p-columnFilter>
                        </th>
                        <th pSortableColumn="Costcenterdesc">
                            Cost Center
                            <p-sortIcon field="Costcenterdesc" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order">
                            </p-sortIcon>
                            <p-columnFilter field="Costcenterid" matchMode="in" display="menu" [showMatchModes]="false"
                                [showOperator]="false" [showAddButton]="false" class="ml-auto">
                                <ng-template #filter let-value let-filter="filterCallback">
                                    <p-multiSelect defaultLabel="Filter" maxSelectedLabels="1" appendTo="body"
                                        [options]="this.costCentersFilterSelectItem" [filter]="true"
                                        styleClass="w-full"
                                                [ngModel]="value"
                                                (ngModelChange)="filter($event)">
                                    </p-multiSelect>
                                </ng-template>
                            </p-columnFilter>
                        </th>
                        <th pSortableColumn="Startdate">
                            Start Date
                            <p-sortIcon field="Startdate" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order">
                            </p-sortIcon>
                            <p-columnFilter field="Startdate" matchMode="in" display="menu" [showMatchModes]="false"
                                [showOperator]="false" [showAddButton]="false" class="ml-auto">
                                <ng-template #filter let-value let-filter="filterCallback">
                                    <p-multiSelect defaultLabel="Filter" maxSelectedLabels="1" appendTo="body"
                                        [options]="this.startDatesFilterSelectItem" [filter]="true"
                                        styleClass="w-full"
                                                [ngModel]="value"
                                                (ngModelChange)="filter($event)">
                                    </p-multiSelect>
                                </ng-template>
                            </p-columnFilter>
                        </th>
                        <th pSortableColumn="Enddate">
                            End Date
                            <p-sortIcon field="Enddate" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order">
                            </p-sortIcon>
                            <p-columnFilter field="Enddate" matchMode="in" display="menu" [showMatchModes]="false"
                                [showOperator]="false" [showAddButton]="false" class="ml-auto">
                                <ng-template #filter let-value let-filter="filterCallback">
                                    <p-multiSelect defaultLabel="Filter" maxSelectedLabels="1" appendTo="body"
                                        [options]="this.endDatesFilterSelectItem" [filter]="true"
                                        styleClass="w-full"
                                                [ngModel]="value"
                                                (ngModelChange)="filter($event)">
                                    </p-multiSelect>
                                </ng-template>
                            </p-columnFilter>
                        </th>
                        <th *ngIf="this.showFR" pSortableColumn="FRR">
                            Fringe %
                            <p-sortIcon field="FRR" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order">
                            </p-sortIcon>
                        </th>
                        <th pSortableColumn="OHR">
                            OH %
                            <p-sortIcon field="OHR" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order">
                            </p-sortIcon>
                        </th>
                        <th *ngIf="this.showMH" pSortableColumn="HoursAccrued">
                            MH %
                            <p-sortIcon field="HoursAccrued" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order">
                            </p-sortIcon>
                        </th>
                        <th *ngIf="this.showM2" pSortableColumn="MHR">
                            MH2 %
                            <p-sortIcon field="MHR" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order">
                            </p-sortIcon>
                        </th>
                        <th pSortableColumn="GAR">
                            G&A %
                            <p-sortIcon field="GAR" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order">
                            </p-sortIcon>
                        </th>
                        <th pSortableColumn="Ceilinginuse">
                            Activity
                            <p-sortIcon field="Ceilinginuse" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order">
                            </p-sortIcon>
                        </th>
                        <th class="delete-cell"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rate let-edit="editing" let-ri="rowIndex">
                    <tr [pEditableRow]="rate" data-id="row-{{ rate.Rateceilingid }}">
                        <td class="edit-cell" pFrozenColumn [frozen]="IsColumnFrozen">
                            <button *ngIf="
                                    !edit &&
                                    (!editing?.id ||
                                        !editing?.id ===
                                            rate?.id)
                                " pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil"
                                (click)="onRowEditInit(rate)" class="p-button-rounded p-button-text" title="Edit"></button>
                            <button *ngIf="edit" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check"
                                (click)="onRowEditSave(rate)" class="
                                    p-button-rounded
                                    p-button-text
                                    p-button-success
                                " style="
                                    margin-right: 0.5em;

                                "></button>
                            <button *ngIf="edit" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times"
                                (click)="onRowEditCancel(rate)" class="
                                    p-button-rounded
                                    p-button-text
                                    p-button-danger
                                "></button>
                        </td>
                        <td class="status-cell" pFrozenColumn [frozen]="IsColumnFrozen">
                            <div>
                                <a (click)="onStatusClick(rate)">
                                    <div>
                                        <ef-status-icon [status]="
                                                rate?.Status?.StatusCode
                                            " [message]="
                                                rate?.Status?.Message
                                            "></ef-status-icon>
                                    </div>
                                </a>
                            </div>
                        </td>
                        <td pFrozenColumn [frozen]="IsColumnFrozen">
                            {{ rate.Contractdesc }}
                        </td>
                        <td>
                            {{ rate.Chargenumber }}
                        </td>
                        <td>
                            {{ rate.Costcenterdesc }}
                            <!-- <p-cellEditor>
                                <ng-template #input>
                                    <p-dropdown appendTo="body" [options]="costCentersSelectItem" [(ngModel)]="rate.Costcenterid">
                                    </p-dropdown>
                                </ng-template>
                                <ng-template #output>

                                </ng-template>
                            </p-cellEditor>                -->
                        </td>
                        <td>
                            <p-cellEditor>
                                <ng-template #input>
                                    <p-calendar appendTo="body" [(ngModel)]="rate.Startdate" [yearNavigator]="true"
                                        [monthNavigator]="true" yearRange="2010:2030">
                                    </p-calendar>
                                </ng-template>
                                <ng-template #output>
                                    {{ moment(rate.Startdate).format('MM/DD/YYYY') }}
                                </ng-template>
                            </p-cellEditor>
                        </td>
                        <td>
                            <p-cellEditor>
                                <ng-template #input>
                                    <p-calendar appendTo="body" [(ngModel)]="rate.Enddate" [yearNavigator]="true"
                                        [monthNavigator]="true" yearRange="2010:2030">
                                    </p-calendar>
                                </ng-template>
                                <ng-template #output>
                                    {{ moment(rate.Enddate).format('MM/DD/YYYY') }}
                                </ng-template>
                            </p-cellEditor>
                        </td>
                        <td *ngIf="this.showFR">
                            <p-cellEditor>
                                <ng-template #input>
                                    <input pInputText type="text" [(ngModel)]="rate.FRR" />
                                </ng-template>
                                <ng-template #output>
                                    {{ rate.FRR }}
                                </ng-template>
                            </p-cellEditor>
                        </td>
                        <td>
                            <p-cellEditor>
                                <ng-template #input>
                                    <input pInputText type="text" [(ngModel)]="rate.OHR" />
                                </ng-template>
                                <ng-template #output>
                                    {{ rate.OHR }}
                                </ng-template>
                            </p-cellEditor>
                        </td>
                        <td *ngIf="this.showMH">
                            <p-cellEditor>
                                <ng-template #input>
                                    <input pInputText type="text" [(ngModel)]="rate.MHR" />
                                </ng-template>
                                <ng-template #output>
                                    {{ rate.MHR }}
                                </ng-template>
                            </p-cellEditor>
                        </td>
                        <td *ngIf="this.showM2">
                            <p-cellEditor>
                                <ng-template #input>
                                    <input pInputText type="text" [(ngModel)]="rate.M2R" />
                                </ng-template>
                                <ng-template #output>
                                    {{ rate.M2R }}
                                </ng-template>
                            </p-cellEditor>
                        </td>
                        <td>
                            <p-cellEditor>
                                <ng-template #input>
                                    <input pInputText type="text" [(ngModel)]="rate.GAR" />
                                </ng-template>
                                <ng-template #output>
                                    {{ rate.GAR }}
                                </ng-template>
                            </p-cellEditor>
                        </td>
                        <td>
                            <i *ngIf="rate.Ceilinginuse == true" class="pi pi-check"></i>
                        </td>
                        <td class="delete-cell">
                            <button pButton type="button" icon="pi pi-trash" (click)="deleteRateCeiling(rate)"
                                class="p-button-text p-button-danger"></button>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </p-accordionTab>
    </p-accordion>
</div>
